module.exports = require("swagger-client");


//////////////////
// WEBPACK FOOTER
// external "swagger-client"
// module id = 240
// module chunks = 0